<template>
  <div class="app-container">
    <div class="screeBox">
      <!-- <div class="head"> -->
      <!-- <el-select
        filterable
        v-if="userInfo.park_id == 0"
        v-model="screen.park_id"
        placeholder="请选择园区"
        class="screenInput"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select> -->
      <el-input
        class="screenInput"
        v-model="screen.name"
        placeholder="请输入姓名"
      ></el-input>
      <el-input
      maxlength="11"
        class="screenInput"
        v-model="screen.phone"
        placeholder="请输入手机号"
      ></el-input>
      <el-button
        size="medium"
        type="primary"
        @click="(screen.page = 1), fetchData()"
        >筛选</el-button
      >
      <el-button size="medium" type="primary" plain @click="chongZhi()"
        >重置</el-button
      >
    </div>

    <div style="margin-top: 20px">
      <el-button
        size="medium"
        type="primary"
        @click="addMenu()"
        v-if="roles.includes('/park/user_add')"
        >添加</el-button
      >
      <el-button
        size="medium"
        type="info"
        @click="downloadFile()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/park/user_import_template')"
        >下载模板</el-button
      >
      <el-button
        size="medium"
        type="success"
        @click="leadIn()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/park/user_import')"
        >导入</el-button
      >
    </div>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :data="list"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="用户姓名">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="昵称">
        <template slot-scope="scope">
          {{ scope.row.nick_name }}
        </template>
      </el-table-column> -->
      <el-table-column label="头像" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.avatar_url"
            class="tableIcon"
            alt=""
            srcset=""
            :src="imageOss + scope.row.avatar_url"
          />
        </template>
      </el-table-column>
      <el-table-column label="手机号" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="园区名称" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.user_park_company_rel.length">
            <span v-for="(item, i) in scope.row.user_park_company_rel" :key="i">
              {{ item.park_name }}
            </span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="账号类型" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? "园区" :scope.row.type == 2 ? "企业" : "集团" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="200"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="roles.includes('/park/user_info')"
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            >查看</el-button
          >
          <el-button
            v-if="roles.includes('/park/user_edit')"
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <!-- <el-button
            size="mini"
            type="danger"
            v-if="roles.includes('/park/user_del')"
            @click="openUserRole(scope.row.id)"
            >查看角色</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      @close="dialogClos"
    >
      <el-form
        :model="ruleForm"
        :rules="cztype != 'see' ? rules : rules1"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input
            :disabled="cztype == 'see'"
            v-model="ruleForm.name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            maxlength="11"
            v-model="ruleForm.phone"
            :disabled="cztype != 'add'"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            :disabled="cztype == 'see'"
            :placeholder="cztype == 'edit' ? '不输入为不修改' : '请输入密码'"
          ></el-input>
        </el-form-item>
        <el-form-item label="头像" prop="icon">
          <el-upload
          :limit="1"
            ref="upload"
            name="file[]"
            :data="{ type: 'image' }"
            :action="ossUpload"
            :file-list="fileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
            :class="fileList.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="ruleForm.sex" :disabled="cztype == 'see'">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
            <el-radio :label="3">保密</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input-number
            style="width: 202px"
            :disabled="cztype == 'see'"
            :precision="0"
            v-model="ruleForm.age"
            :min="0"
            :max="300"
            label="年龄"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="学历" prop="education">
          <el-select
            filterable
            v-model="ruleForm.education"
            placeholder="请选择学历"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.title"
              :value="item.value"
              v-for="(item, index) in educationList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="是否党员" prop="cpc">
          <el-radio-group v-model="ruleForm.cpc" :disabled="cztype == 'see'">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">不是</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="人脸照片" prop="face_url">
          <el-upload
          :limit="1"
            ref="upload"
            name="file[]"
            :data="{ type: 'face' }"
            :action="ossUpload"
            :file-list="faceFileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="faceHandleRemove"
            :on-success="faceHandleAvatarSuccess"
            :disabled="cztype == 'see'"
            :before-upload="faceBeforeAvatarUpload"
            accept=".jpg"
            :class="faceFileList.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
          <div class="pic-tips">
            人脸照片，后缀只能 jpg，图片尺寸必须大于 256*256 小于 6000*6000
          </div>
        </el-form-item>
        <el-form-item
          :label="'园区角色' "
          v-for="(item, index) in domains"
          :key="item.system_role_id + index + item.park_id"
        >
          <!-- <el-select
            filterable
            @change="
              (id) => {
                parkChange(id, index);
              }
            "
            class="w4"
            v-model="item.park_id"
            placeholder="请选择园区"
            :disabled="
              cztype == 'see' || userInfo.type == 2 || userInfo.type == 1
            "
          >
            <el-option
              :disabled="parkids.indexOf(item1.id) != -1 ? true : false"
              :label="item1.name"
              :value="item1.id"
              v-for="(item1, index1) in parkList"
              :key="index1"
            ></el-option>
          </el-select> -->
          <el-cascader
            class="w4"
            placeholder="请选择角色"
            :disabled="cztype == 'see'"
            :value="item.system_role_id"
            :options="roleList[index]"
            :show-all-levels="false"
            @change="
              (e) => {
                roleChange(e, index);
              }
            "
            :props="{
              checkStrictly: true,
              label: 'title',
              value: 'id',
              children: 'nodes',
            }"
            clearable
          ></el-cascader>
          <!-- <el-button
            style="margin: 0 0 0 10px"
            v-if="(domains.length > 1 && cztype == 'add') || (cztype != 'add' && cztype != 'see') "
            type="danger"
            @click.prevent="removeDomain(index)"
            >删除</el-button
          > -->
        </el-form-item>
        <!-- <el-form-item v-if="userInfo.is_super == 1 && cztype != 'see'">
          <el-button type="primary" @click="addDomain">添加园区角色</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog title="用户角色" :visible.sync="userRoleVisible">
      <el-table
        :data="userRoleData"
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      >
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="所属园区">
          <template slot-scope="scope">
            <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="所属企业">
          <template slot-scope="scope">
            <span v-if="scope.row.company">{{ scope.row.company.name }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="角色">
          <template slot-scope="scope">
            <span v-if="scope.row.system_role">{{
              scope.row.system_role.title
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="操作"
          width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              v-if="roles.includes('/park/user_del')"
              @click="handleDelete(scope.row)"
              >删除角色</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="userRoleVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      @close="dialogClos"
      :close-on-click-modal="false"
      title="导入文件"
      :visible.sync="leadInVisible"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="baseURL + '/park/user_import'"
        :headers="{ token: token }"
        drag
        :limit="1"
        :on-success="handleAvatarSuccessFile"
        :on-progress="beforeAvatarUploadFile"
        :multiple="false"
        accept=".xlsx"
      >
        <!-- accept=".xlsx,.xls" -->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
        <!-- ，且不超过500kb -->
      </el-upload>
      <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
      <div class="error" v-if="msgData.length > 0">
        <div v-for="(item, index) in msgData" :key="index">{{ item }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leadInVisible = false">取 消</el-button>
        <el-button type="primary" @click="leadInVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  parkUser,
  addParkUser,
  editParkUser,
  delParkUser,
  parkUserInfo,
  openPark,
  delImage,
  openRole,
  miniUserRole,
  templatePark_user,
} from "@/api/index";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageOss"]),
  },
  data() {
    return {
      // 学历列表
      educationList: [
        {
          title: "小学",
          value: 2,
        },
        {
          title: "初中",
          value: 3,
        },
        {
          title: "高中",
          value: 4,
        },
        {
          title: "专科",
          value: 5,
        },
        {
          title: "本科",
          value: 6,
        },
        {
          title: "研究生",
          value: 7,
        },
        {
          title: "其他",
          value: 1,
        },
      ],
      total: 0,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加园区",
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        name: "",
        phone: "",
        park_id: "",
        nick_name: "",
      },
      ruleForm: {
        phone: "",
        name: "",
        status: 1,
        park_role_data: "",
        avatar_url: "",
        sex: 3,
        age: 0,
        education: "",
        password: "",
        face_url: "",
      },
      rules1: {},
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        password: [
          {
            required: true,
            message: "请输入密码,最少6位",
            trigger: "blur",
            min: 6,
          },
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      multipleSelection: [],
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      oldImg: "",
      parkList: [],
      userRoleVisible: false,
      userRoleData: [],
      roleList: [],
      parkids: [],
      domains: [{ system_role_id: "", park_id: "" }],
      leadInVisible: false,
      baseURL: this.$store.state.baseURL,
      fileList: [],
      loadProgress: 0,
      progressFlag: false,
      msgData: [],
      faceFileList: [],
    };
  },
  created() {
    if (this.userInfo.is_super != 1) {
      if (this.userInfo.type == 1) {
        this.screen.park_id = this.userInfo.park_id;
      } else if (this.userInfo.type == 2) {
        this.screen.park_id = this.userInfo.park_id;
      }
    } else {
      this.screen.park_id = "";
    }
    // this.getPark();
    this.fetchData();
  },
  methods: {
    // 人脸识别
    faceHandleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        // if (this.ruleForm.face_url) {
        //   this.delImg(this.ruleForm.face_url);
        // }
        this.faceFileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.face_url = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.faceFileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 人脸识别删除
    faceHandleRemove(file) {
      this.faceFileList = [];
      this.ruleForm.face_url = "";
    },
    // 人脸识别上传限制
    faceBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传人脸图片大小不能超过 5MB!");
        return false;
      }
      return isLt5M;
    },
    handleRemove(file) {
      this.fileList = [];
      this.ruleForm.avatar_url = "";
    },
    dialogClos() {
      this.parkids = [];
      this.msgData = [];
      this.$refs.upload.clearFiles();
    },
    // 上传成功
    handleAvatarSuccessFile(res, file) {
      if (res.code === 200) {
        this.$message({
          message: res.msg,
          type: "success",
          duration: "1000",
          onClose: () => {
            //onClose是message消息框消失后要执行的回调
            //此处写提示关闭后需要执行的函数
          },
        });

        this.$refs.upload.clearFiles();

        this.leadInVisible = false;
      } else {
        this.$refs.upload.clearFiles();
        this.msgData = res.data;
        this.$message({
          message: res.msg,
          type: "error",
          duration: "2000",
        });
      }
      this.fetchData();
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 上传进度
    beforeAvatarUploadFile(event, file, fileList) {
      this.progressFlag = true;
      this.loadProgress = Math.floor(event.percent);
      let loadProgress = Math.floor(event.percent); //这就是当前上传的进度
      //可以进行其他逻辑
      if (loadProgress == 100) {
        this.progressFlag = false;
      }
    },
    // 导入
    leadIn() {
      this.leadInVisible = true;
    },
    // 下载模板
    downloadFile() {
      templatePark_user().then((res) => {
        if (res.code == 200) {
          window.open(res.data.download_url, "_self");
        }
      });
    },
    roleChange(e, index) {
      if (e.length) {
        this.domains[index].system_role_id = e[0];
      } else {
        this.domains[index].system_role_id = "";
      }
    },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        name: "",
        phone: "",
        park_id: "",
        nick_name: "",
      };
      if (this.userInfo.is_super != 1) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    // 获取角色
    openUserRole(id) {
      var data = {
        user_id: id,
        park_id: this.userInfo.park_id,
        company_id: this.userInfo.company_id,
        source: 1,
      };
      miniUserRole(data).then((res) => {
        this.userRoleData = res.data.lists;
        this.userRoleVisible = true;
      });
    },
    // 获取角色
    getRole(id, index) {
      const data = {
        is_page: 2,
        is_tree: 1,
        role_type: 2,
        type: 1,
        park_id: id || "",
      };
      openRole(data).then((res) => {
        this.$set(this.roleList, index, res.data.lists);
      });
    },
    // 选择园区
    parkChange(id, index) {
      this.parkids = [];
      this.getRole(this.$store.state.mainParkId, index);
      this.domains[index] = { park_id: this.$store.state.mainParkId, system_role_id: "" };
      this.domains.forEach((item) => {
        if (item.park_id) {
          this.parkids.push(item.park_id);
        }
      });
    },
    // 添加园区角色
    addDomain() {
      this.domains.push({ park_id: "", system_role_id: "" });
      if (this.userInfo.is_super != 1) {
        this.domains[this.domains.length - 1].park_id = this.userInfo.park_id;
      }
    },
    // 删除园区角色
    removeDomain(index) {
     // this.parkids = [];
      var i = this.parkids.findIndex((item) => {
        return item == this.domains[index].park_id;
      });
      if (i != -1) {
        this.parkids.splice(i, 1);
      }
      this.roleList.splice(index, 1);
      this.domains.splice(index, 1);
    },

    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // var chone = 0;
          // this.domains.forEach((item) => {
          //   if (item.park_id && item.system_role_id) {
          //   } else {
          //     this.$message({
          //       message: "园区角色未填写完整！",
          //       type: "warning",
          //     });
          //     chone++;
          //     return;
          //   }
          // });
          // if (chone != 0) {
          //   return;
          // }
          this.$confirm("确认提交？")
            .then(() => {
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
              });
              that.ruleForm.park_role_data = JSON.stringify(that.domains);
              editParkUser(that.ruleForm).then((res) => {
                loading.close();
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  // if (this.oldImg) {
                  //   that.delImg(this.oldImg);
                  // }
                  this.fileList = [];
                  this.faceFileList = [];
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      // if (res.code === 200) {
      //   if (this.ruleForm.avatar_url) {
      //     this.delImg(this.ruleForm.avatar_url);
      //   }
      //   this.ruleForm.avatar_url = res.data.url;
      // }
      if (res.code === 200) {
        // if (this.ruleForm.avatar_url) {
        //   this.delImg(this.ruleForm.avatar_url);
        // }
        this.fileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.avatar_url = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
    },
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.domains = [];
      this.getInfo(val.id);
      this.oldImg = val.picture;
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.domains = [];
      this.getInfo(val.id);
      this.drawer = true;
    },
    getInfo(id) {
      var that = this;
      var data = {
        id: id,
        park_id: this.userInfo.park_id,
      };
      parkUserInfo(data).then((res) => {
        this.ruleForm = {
          id: res.data.info.id,
          password: res.data.info.password || "",
          phone: res.data.info.phone,
          name: res.data.info.name,
          status: res.data.info.status,
          avatar_url: res.data.info.avatar_url,
          sex:
            res.data.info.user_extend !== null
              ? res.data.info.user_extend.sex
              : 3,
          age:
            res.data.info.user_extend !== null
              ? res.data.info.user_extend.age
              : 3,
          education:
            res.data.info.user_extend !== null
              ? res.data.info.user_extend.education
              : "",
        };
        var list = res.data.info.user_park_company_rel;
        this.oldImg = res.data.info.avatar_url;
        this.fileList = [];
        if (res.data.info.avatar_url) {
          this.fileList.push({ url: this.imageOss + res.data.info.avatar_url });
        }
        this.faceFileList = [];
        if (res.data.info.face) {
          res.data.info.face.forEach((item, index) => {
            if (index == 0) {
              this.ruleForm.face_url = item.image;
            }
            this.faceFileList.push({ url: this.imageOss + item.image });
          });
        }

        if (list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            that.domains.push({
              park_id: list[i].park_id || "",
              system_role_id: list[i].system_role_id,
            });
            if (list[i].park_id) {
              this.parkids.push(list[i].park_id);
            }
            this.getRole(list[i].park_id, i);
          }
        }
      });
    },
    handleDelete(val) {
      const data = {
        id: val.user_id,
        role_id: val.system_role_id,
        park_id: val.park_id,
        company_id: val.company_id,
      };
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          delParkUser(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            // that.openUserRole(val.user_id);
            that.userRoleVisible = false;
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var chone = 0;
          this.domains.forEach((item) => {
            if (item.park_id && item.system_role_id) {
            } else {
              this.$message({
                message: "园区角色未填写完整！",
                type: "warning",
              });
              chone++;
              return;
            }
          });
          if (chone != 0) {
            return;
          }
          this.$confirm("确认提交？")
            .then(() => {
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
              });
              that.ruleForm.park_role_data = JSON.stringify(that.domains);
              addParkUser(that.ruleForm).then((res) => {
                loading.close();
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  this.fileList = [];
                  this.faceFileList = [];
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.parkids = [];
      this.$confirm("确认关闭？")
        .then(() => {
          this.fileList = [];
          this.faceFileList = [];
          this.$refs.ruleForm.clearValidate();
          done();
        })
        .catch(() => {});
    },
    addMenu() {
      this.drawerTitle = "添加用户";
      this.cztype = "add";
      this.fileList = [];
      this.faceFileList = [];
      this.ruleForm = {
        phone: "",
        name: "",
        status: 1,
        park_role_data: "",
        avatar_url: "",
        sex: 3,
        age: 0,
        education: "",
        password: "",
        face_url: "",
      };
      this.domains = [{ park_id: this.$store.state.mainParkId, system_role_id: "" }];
      // if (this.userInfo.is_super != 1) {
      //   this.domains[0].park_id = this.userInfo.park_id;
      //   this.getRole(this.userInfo.park_id, 0);
      // }
       this.getRole(this.$store.state.mainParkId, 0);
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    delParkUser() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个用户");
        return;
      }
      this.$confirm("确认删除？")
        .then(() => {
          delParkUser({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.fileList = [];
      this.faceFileList = [];
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      parkUser(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  display: flex;
  flex-wrap: wrap;
  .btn {
    display: inline-block;
  }
}

// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin: 0 10px 5px 0;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
.upload-demo {
  ::v-deep .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
}
.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>
